import React from 'react'

const Edu = () => {
    return (
        <div className='pick'>
            <h2 className='h2Title'>Education</h2>
            <h3 className='EduTitle'>
                <p>
                    Lambda School online classes studying to be a Full stack web developer from April 2020 to September 2021, Enrolled
                </p>
                <p>
                    Rexburg College of Massage Thereapy in Rexburg, ID from Janurary 2017 to August 2017, Graduated
                </p>
                <p>
                    Maize South High School in Wichita KS from September 2010 to May 2011, Graduated
                </p>
                <p>
                    New Market Vocational Skills Center in Tumwater WA from Sept 2009 to July 2010, Transferred
                </p>
                <p>
                    Tumwater High School in Tumwater WA from Sept 2007 to July 2010, Transferred
                </p>

            </h3>

           
        </div>
    )
}

export default Edu